import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import CardPage from "./pages/CardPage";
import AdminEmployees from "./pages/admin/AdminEmployees";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminShell from "./pages/admin/AdminShell";
import AppHome from "./pages/app/AppHome";
import AppInstall from "./pages/app/AppInstall";
import AppLeads from "./pages/app/AppLeads";
import AppLogin from "./pages/app/AppLogin";
import AppProfile from "./pages/app/AppProfile";
import AppScan from "./pages/app/AppScan";

type Health = { status: string; version: string; environment: string };

function Home() {
  const [health, setHealth] = useState<Health | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const base = import.meta.env.VITE_API_BASE ?? "";
    fetch(`${base}/healthz`)
      .then(async (r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return (await r.json()) as Health;
      })
      .then(setHealth)
      .catch((e: Error) => setError(e.message));
  }, []);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center p-8">
      <div className="max-w-md text-center space-y-4">
        <h1 className="font-display text-3xl font-bold">
          sahab<span className="text-signal">.</span>
        </h1>
        <p className="text-ink/70">Sahab Systems Digital vCard — scaffold OK.</p>
        <div className="font-mono text-xs text-ink/60 border border-ink/10 rounded p-3 bg-paper">
          {error && <span className="text-red-600">api unreachable: {error}</span>}
          {health && (
            <span>
              api {health.version} · {health.environment} · {health.status}
            </span>
          )}
          {!health && !error && <span>checking api…</span>}
        </div>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<AdminShell />}>
        <Route index element={<Navigate to="leads" replace />} />
        <Route path="leads" element={<AdminLeads />} />
        <Route path="employees" element={<AdminEmployees />} />
      </Route>
      <Route path="/app" element={<AppHome />} />
      <Route path="/app/login" element={<AppLogin variant="login" />} />
      <Route path="/app/welcome" element={<AppLogin variant="welcome" />} />
      <Route path="/app/install" element={<AppInstall />} />
      <Route path="/app/profile" element={<AppProfile />} />
      <Route path="/app/scan" element={<AppScan />} />
      <Route path="/app/leads" element={<AppLeads />} />
      <Route path="/:slug" element={<CardPage />} />
      <Route path="*" element={<div className="p-8">Not found</div>} />
    </Routes>
  );
}
